import { singleton } from "tsyringe";
import { Config } from "../config";
import { Channel, Layer, Event } from "../models/channelClass";
import { ViewType } from '../models/layoutClass';
import { fetchAndGetArrayBuffer, fetchAndGetText, fetchAndThrowHttpErrors, uuidv4 } from "../utils/helpers";

import { BehaviorSubject, Subject, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

import * as _ from 'lodash';
import * as R from 'ramda';

const CLASSIC_IMAGE = '/images/space-style.png';

import { MediaService } from './media-service';
import { container } from 'tsyringe';
import { MediaType, Media } from '../models/mediaClass';
import { ProducerType } from '../models/producerClass';

import { TemplateType } from '../models/templateClass';
import { TemplateService } from './template-service';
import { ErrorService } from "./error-service";
import { UserService } from "./user-service";
import { BroadcastService } from "./broadcast-service";
import { PTApiService } from "./ptapi-service";

declare var SockJS: any;
import * as StompJS from '@stomp/stompjs';

@singleton()
export class ApiService {

  public myAttributesUpdateNumber = 0;
  public _updateReason: any = undefined;
  public myUuid = null;

  private mediaService = container.resolve(MediaService);
  private templateService = container.resolve(TemplateService);
  private errorService = container.resolve(ErrorService);
  private ptApiService = container.resolve(PTApiService);
  private broadcastService = container.resolve(BroadcastService);
  private lastUpdateSent = null;

  public displayedChannel$ = new BehaviorSubject<Channel>(null);
  public event$: BehaviorSubject<Event> = new BehaviorSubject<Event>({});
  private endpointUrl = `${Config.BACKEND_API_URL}`;

  private _backgroundLayer: any = null;
  private _swapArray = [];
  private _forceLayerSend = false;

  public eventName$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public layers$: BehaviorSubject<Layer[]> = new BehaviorSubject<Layer[]>([]);
  public selectedBackground$: BehaviorSubject<{}> = new BehaviorSubject<{}>({});
  public fgImage$: BehaviorSubject<{}> = new BehaviorSubject<{}>({});
  public fgVideo$: BehaviorSubject<{}> = new BehaviorSubject<{}>({});
  public layoutView$: BehaviorSubject<string> = new BehaviorSubject<string>(ViewType.CLASSIC);
  public brandSettings$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public templates$: BehaviorSubject<Layer[]> = new BehaviorSubject<Layer[]>([]);
  public templateAttributes$: BehaviorSubject<{}> = new BehaviorSubject<{}>({});
  public producerOrderSet$: BehaviorSubject<[]> = new BehaviorSubject<[]>([]);
  public producerOrder$: BehaviorSubject<[]> = new BehaviorSubject<[]>([]);
  public spottedProducer$ = new BehaviorSubject<any>(null);

  public channelList$: BehaviorSubject<Channel[]> = new BehaviorSubject<Channel[]>(null);

  public updateChannelQueue$ = new Subject();
  public registerPopupQueue$ = new BehaviorSubject<boolean>(false);

  public templateCache: any[] = [];
  public fontCache: any[] = [];

  private stompClient = null;
  private brokerSubscription = null;

  public set updateReason(value) {
    this._updateReason = { ...value, fromUuid: this.myUuid };
  }

  public toggleRegisterPopup() {
    const value = this.registerPopupQueue$.getValue();
    this.registerPopupQueue$.next(!value);
  }
  public closeRegisterPopup() {
    this.registerPopupQueue$.next(false);
  }

  public get currentlyDisplayedChannel() {
    return this.displayedChannel$.value;
  }

  public LAYERSNEXT(value) {
    console.log('LAYERSNEXT', value);
    this.layers$.next(value);
  }

  constructor() {
    console.log('api-service constructor');

    this.initMessageBrokerConnection();

    // console.log(window.location.search);
    // const params = qs.parse(window.location.search);
    // console.log(params);

    // if (params.channel) {
    //   this.requestedChannel = params.channel;
    // }

    this.templateAttributes$.next([]);

    this.updateChannelQueue$
      .pipe(debounce(() => interval(500)))
      .subscribe(async (value) => {
        try {
          await this.processSaveChannel(value);
        } catch (e) {
          this.displayError(e);
        }
      });

  }

  //  STOMPJS
  // public disconnectBroker() {
  //   if (this.brokerSubscription) {
  //     this.brokerSubscription.unsubscribe();
  //   }
  // }

  private initMessageBrokerConnection() {
    console.log("Socket check enabled.")
    // if (Config.MESSAGE_BROKER.ENABLED) {
    //   console.log("Socket initializing.")

    //   const stompConfig = {

    //     // Broker URL, should start with ws:// or wss:// - adjust for your broker setup
    //     brokerURL: Config.BACKEND_WS_URL.replace('https', 'wss'),
    //     // we are still using https on backend side
    //     webSocketFactory: () => {
    //       return new SockJS(Config.BACKEND_WS_URL)
    //     },

    //     // Keep it off for production, it can be quit verbose
    //     // Skip this key to disable
    //     debug: (str) => {
    //       console.log();
    //       // uncomment for debug
    //       // console.log('STOMP: ' + str);
    //     },

    //     // If disconnected, it will retry after 200ms
    //     reconnectDelay: 200,
    //     heartbeatIncoming: 4000,
    //     heartbeatOutgoing: 4000,

    //     // Subscriptions should be done inside onConnect as those need to reinstated when the broker reconnects
    //     onConnect: (frame) => {
    //       // console.log('Subscribing to /topic/', this.currentlyDisplayedChannel.uuid);
    //       this.brokerSubscription = this.stompClient.subscribe(`/topic/${this.currentlyDisplayedChannel.uuid}`, (message) => {
    //         try {
    //           // console.log("Socket Received message !!", message);
    //           const channel = JSON.parse(message.body) as Channel;
    //           this.reactToChannelChangeFromSocket(channel)
    //         } catch (err) {
    //         }
    //       });
    //     }
    //   };
    //   this.stompClient = new StompJS.Client(stompConfig);
    // }
  }

  private subscribeToChannelTopic(channelId: String) {
    console.log("Socket subscribing to channel", channelId);

    this.stompClient.activate();
  }

  private async reactToChannelChangeFromSocket(channel: Channel) {
    console.log("YOLO! Socket received a channel update from socket : ", channel);

    if (this.lastUpdateSent && this.lastUpdateSent.eventStatus !== channel.eventStatus) {
      this.lastUpdateSent.eventStatus = channel.eventStatus;
      this.event$.next({ uuid: channel.uuid, name: channel.name, status: channel.eventStatus });
      // this.event$.next(await fetchAndThrowHttpErrors(`${this.endpointUrl}/event/${this.currentlyDisplayedChannel.eventId}`, {
      //   headers: {}
      // }) as Event);
    }

    const rcvdChannel = {
      ...channel,
      templateAttributes: JSON.parse(channel.templateAttributes),
      updateReason: JSON.parse(channel.updateReason),
    };

    if (rcvdChannel.updateReason.fromUuid !== this.myUuid) {
      const reason = this.notSameChannel(rcvdChannel, this.lastUpdateSent);
      if (reason.length > 0) {

        this._updateReason = rcvdChannel.updateReason;
        console.log('YOLO process update reason=', reason);

        this.processChannel(rcvdChannel);
      } else {
        console.log('YOLO: nothing to dispatch');
      }
    }
  }

  private displayError(e) {
    this.errorService.throwError({
      type: 'unknown',
      code: 'API_BACKEND_ERROR',
      message: e
    });
  }

  public async getChannelByEventId(ptEventId: string, ptEventInstanceId: string) {
    try {
      const channel = await fetchAndThrowHttpErrors(`${this.endpointUrl}/channel?ptEventId=${ptEventId}&ptEventInstanceId=${ptEventInstanceId}`, {
        headers: this.ptApiService.addPTUserAuthenticationHeader({})
      }) as Channel;

      return channel;
    } catch (e) { /* Mask error, server will answer 404 if channel is not there */ }
  }

  public async deleteChannel(channelId: string) {
    await fetchAndThrowHttpErrors(`${this.endpointUrl}/channel/${channelId}`, {
      method: 'DELETE',
      headers: this.ptApiService.addPTUserAuthenticationHeader({})
    });
  }

  public async getChannelsAvailable() {

    console.log('getChannelsAvailable');

    try {
      const channels = await fetchAndThrowHttpErrors(`${this.endpointUrl}/channel/list`, {
        headers: this.ptApiService.addPTUserAuthenticationHeader({})
      }) as Channel[];

      this.channelList$.next(channels);
    } catch (e) {
      // not connected ->send empty channel list
      this.channelList$.next([]);
    }
  }


  public async getChannelInfos(channelid) {

    // const dispatch = useDispatch();
    if (channelid !== 'testing') {

      // initialize myUuid
      this.myUuid = uuidv4();


      try {
        const channel = await fetchAndThrowHttpErrors(`${this.endpointUrl}/channel/${channelid}`, {
          headers: this.ptApiService.addPTUserAuthenticationHeader({})
        }) as Channel;
        if (channel) {

          let templateAttributes = null;
          try {
            if (channel.templateAttributes) {
              templateAttributes = JSON.parse(channel.templateAttributes);
            }
          } catch (e) {
            console.log('Failed to parse attributes', channel.templateAttributes, e);
          }
          let updateReason = null;
          try {
            updateReason = JSON.parse(channel.updateReason);
          } catch (e) {
            console.log('Failed to parse updateReason', channel.updateReason, e);
          }

          const rcvdChannel = {
            ...channel,
            templateAttributes,
            updateReason,
          };

          // discard latest action from this dashboard
          if ( rcvdChannel.updateReason && rcvdChannel.updateReason.fromUuid === localStorage.getItem('myPreviousDashboardUuid')) {
            rcvdChannel.updateReason = null;
          }
          // store new uuid
          localStorage.setItem('myPreviousDashboardUuid', this.myUuid);

          this._updateReason = rcvdChannel.updateReason;

          this.processChannel(rcvdChannel);
          this.event$.next({ uuid: rcvdChannel.uuid, name: rcvdChannel.name, status: rcvdChannel.eventStatus });
          this.subscribeToChannelTopic(this.currentlyDisplayedChannel.uuid);

          return rcvdChannel;
        } else {
          this.displayError('This chanelID doesnt exist ! ' + channelid);
        }
      } catch (e) {
        this.displayError(e);
        // alert('This chanelID doesnt exist ! ' + channelid);
      }

      // this.event$.next(await fetchAndThrowHttpErrors(`${this.endpointUrl}/event/${this.currentlyDisplayedChannel.eventId}`, {
      //     headers: {}
      // }) as Event);

    } else {
      // initialize myUuid
      this.myUuid = "demo-demo-demo-demo";
      const eventName = localStorage.getItem('eventName');
      if (eventName) {
        this.eventName$.next(eventName);
      } else {
        this.eventName$.next('Demo');
      }

      // initialize myUuid
      console.log('NO BACKEND SERVER CONNECTED - using test mode');
    }

    console.log('using channel', this.currentlyDisplayedChannel);
    return;
  }

  private async processChannel(channel: Channel) {

    this.lastUpdateSent = {
      layers: channel.layers,
      name: channel.name,
      layout: channel.layout,
      eventStatus: channel.eventStatus,
      brandSettings: channel.brandSettings,
      templateAttributes: channel.templateAttributes,
      updateReason: channel.updateReason,
      producerOrder: channel.producerOrder,
      mediaAction: channel.mediaAction,
    };

    this.displayedChannel$.next(channel);
    this.eventName$.next(channel.name || '');
    this.layoutView$.next(channel.layout as ViewType || ViewType.CLASSIC);
    this.brandSettings$.next(channel.brandSettings || '');

    this.LAYERSNEXT(channel.layers.filter(l => l.type === ProducerType.PRODUCER) || []);
    this.producerOrder$.next(JSON.parse(channel.producerOrder));

    const backgroundLayer = channel.layers?.find(l => (l.type === MediaType.BG_IMAGE || l.type === MediaType.BG_VIDEO));
    this.selectedBackground$.next(backgroundLayer);

    const fgImageLayer = channel.layers.find(l => l.type === MediaType.FG_IMAGE);
    this.fgImage$.next(fgImageLayer);
    const fgVideoLayer = channel.layers.find(l => l.type === MediaType.FG_VIDEO);
    this.fgVideo$.next(fgVideoLayer);


    // this.event$.next(await fetchAndThrowHttpErrors(`${this.endpointUrl}/event/${this.currentlyDisplayedChannel.eventId}`, {
    //   headers: {}
    // }) as Event);

    // this.myAttributesUpdateNumber = channel.templateAttributes.update;

    // make updates on REMOVE first
    if (channel.updateReason) {
      this.templateService.processUpdate(channel.updateReason);
      this.mediaService.processUpdate(channel.updateReason);
    }

    if (channel.templateAttributes) {
      this.templateService.processAttributes(channel.templateAttributes);
    }

  }

  // public set backgroundLayer(backgroundLayer) {
  //   this._backgroundLayer = backgroundLayer;
  // }
  // public get backgroundLayer() {
  //   return this._backgroundLayer;
  // }

  public async saveChannel(from, updatedLayers = null) {


    if (this.currentlyDisplayedChannel?.uuid) {


      console.log("save channel from=", from, 'reason=', this._updateReason);

      let layers: any[] = this.layers$.getValue();
      const name: any = this.eventName$.getValue();
      const background: any = this.selectedBackground$.getValue();
      const layout: any = this.layoutView$.getValue();

      // const templateAttributes: any[] = this.templateAttributes$.getValue();
      const fgVideos: any[] = this.mediaService.fgVideos$.getValue();
      const fgImages: any[] = this.mediaService.fgImages$.getValue();

      const brandSettings: any = this.brandSettings$.getValue();
      const templateAttributes = this.templateAttributes$.getValue();
      const producerOrder = this.producerOrderSet$.getValue();

      console.log(templateAttributes);

      layers = layers.filter(l => l.type !== MediaType.BG_IMAGE && l.type !== MediaType.BG_VIDEO);
      if (background) {
        // add background at layers's first position
        layers.unshift(background);
      }

      if (fgVideos.length > 0) {
        const video: any = fgVideos.find(v => v.selected);
        if (video && video.hls !== '') {
          // add a video layer
          layers.push({
            number: 20000,
            sourceUrl: video.hls,
            sourceId: video.id,
            sourceName: video.name,
            isHidden: false,
            isSpotted: true,
            liveRank: Date.now(),
            type: ProducerType.VIDEO,
            position: { x: 0, y: 0, width: 1, height: 1 },
            crop: { top: 0, left: 0, bottom: 1, right: 1 },
          })
        }
      }
      if (fgImages.length > 0) {
        const image: any = fgImages.find(i => i.selected);
        if (image) {
          // add an image layer
          layers.push({
            number: 20000,
            sourceUrl: image.source,
            sourceId: image.id,
            sourceName: image.name,
            isHidden: false,
            isSpotted: true,
            liveRank: Date.now(),
            type: ProducerType.IMAGE,
            position: { x: 0, y: 0, width: 1, height: 1 },
            crop: { top: 0, left: 0, bottom: 1, right: 1 },
          })
        }
      }

      let update = {
        layers,
        name,
        layout,
        brandSettings,
        templateUrl: `${Config.DASHBOARD_URL}${process.env.PUBLIC_URL}/templates/common_template.html`,
        templateAttributes,
        producerOrder: JSON.stringify(producerOrder),
        eventStatus: this.currentlyDisplayedChannel.eventStatus,
        updateReason: this._updateReason,
      };
      if (this._updateReason?.fromUuid === this.myUuid) {

        const reason = this.notSameChannel(update, this.lastUpdateSent);
        if (reason.length > 0) {

          console.log('YOLO reason=', reason, this._updateReason);
          this.lastUpdateSent = { ...update };

          // enqueue this update into sendQueue$
          this.updateChannelQueue$.next(
            {
              ...update,
              templateAttributes: JSON.stringify(templateAttributes),
              updateReason: JSON.stringify(update.updateReason),
            }
          );

        } else {
          // nothing to update
          return null;
        }
      } else {
        // channel not yet received from server -> wait for init
        return null;
      }
    } else {
      // not connected
      return null;
    }
  }

  private async processSaveChannel(update) {

    const swap: any = this._swapArray;
    console.log('SWAP', swap);
    // check that swap can be send now
    let sendSwap = true;

    for (const number of swap) {
      const layer = update.layers.find(l => l.number === number);
      if (!layer) {
        sendSwap = false;
      }
    }

    console.log('process Save Channel', update);

    // const updateWithSwap = (from === 'producers' && swap && swap.length % 2 == 0) ?
    const updateWithSwap = (swap && swap.length % 2 == 0 && sendSwap) ? { ...update, swap } : { ...update };

    if (sendSwap) {
      this._swapArray = [];
    }

    return await fetchAndThrowHttpErrors(`${this.endpointUrl}/channel/${this.currentlyDisplayedChannel.uuid}`, {
      method: 'PUT',
      body: JSON.stringify(_.omit(updateWithSwap, 'eventStatus')),
      headers: this.ptApiService.addPTUserAuthenticationHeader({})
    });

  }

  public async createChannel(channel) {
    try {
      return await fetchAndThrowHttpErrors(`${this.endpointUrl}/channel`, {
        method: 'POST',
        body: JSON.stringify(channel),
        headers: this.ptApiService.addPTUserAuthenticationHeader({})
      });
    } catch (e) {
      this.displayError(e);
    }
  }

  public async resync() {
    if (this.currentlyDisplayedChannel?.uuid) {
      return await fetchAndThrowHttpErrors(`${this.endpointUrl}/channel/${this.currentlyDisplayedChannel.uuid}/resync`, {
        method: 'POST',
        body: JSON.stringify({}),
        headers: this.ptApiService.addPTUserAuthenticationHeader({})
      });
    } else {
      return null;
    }
  }

  public isEventStatusNew() {
    if (this.currentlyDisplayedChannel) {
      return (this.currentlyDisplayedChannel.eventStatus === 'NEW' ||
        this.currentlyDisplayedChannel.eventStatus === null);
    }
    return false;
  }

  public async goLive(outputStreams) {
    if (!this.currentlyDisplayedChannel || !this.currentlyDisplayedChannel.uuid) {
      throw new Error('Cannot go Live: currentlyDisplayedChannel or currentlyDisplayedChannel uuid not set');
    }

    if (!['NEW', 'TERMINATED', null].includes(this.currentlyDisplayedChannel.eventStatus)) {
      throw new Error(`Cannot go Live: incorrect event status. Event status is ${this.currentlyDisplayedChannel.eventStatus}`);
    }

    await fetchAndThrowHttpErrors(`${this.endpointUrl}/channel/${this.currentlyDisplayedChannel.uuid}/golive`, {
      method: 'POST',
      body: JSON.stringify(outputStreams),
      headers: this.ptApiService.addPTUserAuthenticationHeader({})
    });

    // We do not receive socket messages for self updates
    this.currentlyDisplayedChannel.eventStatus = 'LIVE';

    this.saveChannel('golive');
  }

  public async stopLive() {
    if (!this.currentlyDisplayedChannel || !this.currentlyDisplayedChannel.uuid) {
      throw new Error('Cannot stop Live: currentlyDisplayedChannel or currentlyDisplayedChannel uuid not set');
    }

    if (!['LIVE'].includes(this.currentlyDisplayedChannel.eventStatus)) {
      throw new Error(`Cannot stop Live: incorrect event status. Event status is ${this.currentlyDisplayedChannel.eventStatus}`);
    }

    await fetchAndThrowHttpErrors(`${this.endpointUrl}/channel/${this.currentlyDisplayedChannel.uuid}/stoplive`, {
      method: 'POST',
      body: JSON.stringify({}),
      headers: this.ptApiService.addPTUserAuthenticationHeader({})
    });

    // We do not receive socket messages for self updates
    this.currentlyDisplayedChannel.eventStatus = 'NEW';

    this.saveChannel('stoplive');
  }

  public async videoControl(command, frame = 0) {

    if (this.currentlyDisplayedChannel?.uuid) {

      // predefined constant - sync with backend
      const casparLayerForVideo = 20000;

      let url = `${this.endpointUrl}/channel/${this.currentlyDisplayedChannel.uuid}/layer/${casparLayerForVideo}/${command}`;
      if (command === 'seek') {
        url += '/' + frame;
      }
      try {
        return await fetchAndThrowHttpErrors(url, {
          method: 'POST',
          body: JSON.stringify({}),
          headers: this.ptApiService.addPTUserAuthenticationHeader({})
        });
      } catch (e) {
        this.displayError(e);
      }
    } else {
      return null;
    }
  }


  public swapLayers(swappedLayers) {
    this._swapArray = swappedLayers;
  }

  public set forceLayerSend(value) {
    this._forceLayerSend = value;
  }
  public get forceLayerSend() {
    return this._forceLayerSend;
  }

  public async getTemplate(name) {
    if (this.templateCache[name]) {
      return this.templateCache[name];
    }
    // const dispatch = useDispatch();
    const response = await fetchAndGetText(`${this.endpointUrl.replace('/api', '')}/public/templates/${name}`);
    if (response.length > 0) {
      // const bodyMatch = response.match(/<body[^>]*>[\s\S]*<\/body>/gi);
      // let body = '';
      // if (bodyMatch.length >= 1) {
      //   body = bodyMatch[0].replace('<body>', '').replace('</body>', '');
      // }
      // console.log('body', body);
      this.templateCache[name] = response;
      return response;
    }
    return null;
  }

  public async getFont(name) {
    if (this.fontCache[name]) {
      return this.fontCache[name];
    }
    // const dispatch = useDispatch();
    const response = await fetchAndGetArrayBuffer(`${this.endpointUrl.replace('/api', '')}/public/templates/${name}`);

    this.fontCache[name] = response;

    return response;
  }

  /*
    // istanbul ignore next
  addFloorPlanImage(
    floorUuid: string,
    newscale: number,
    imagedata: string,
    floorName: string
  ) {
    let headers = this.buildHeaders(false);
    const url = `${this.apiUrl}${this.baseUrl}/floorplan/addFloorPlanImage/uuid/${floorUuid}`;

    const formData = new FormData();

    // add scale
    const scale = parseFloat(newscale.toString()).toFixed(4);
    formData.append('scale', scale.toString());

    // add image data (base64)
    // Split the base64 string in data and contentType
    const block = imagedata.split(';');
    // Get the content type of the image
    const contentType = block[0].split(':')[1]; // In this case "image/png"
    // get the real base64 content of the file
    const realData = block[1].split(',')[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."

    // Convert it to a blob to upload
    const blob = this.b64toBlob(realData, contentType, 512);

    // add blob into form
    formData.append('floorPlanImageFile', blob, 'floor_' + floorName + '.png');

    const fileHash = this.toHex(sha256.hash(this.convertDataURIToBinaryFF(imagedata)));
    console.log(fileHash);
    headers = headers.append('FileHash', fileHash);

    // POST /api/floorplan/addFloorPlanImage/uuid/{uuid}
    return this.http.post(url, formData, { headers: headers }).pipe(
      map(res => res) // result is a IFloorPlanImageFileSet
      // handle errors in subscribe ( 409 -> hash not matching)
    );

  }
  */

  // istanbul ignore next
  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return <File>theBlob;
  }

  /**
   * Convert a base64 string in a Blob according to the data and contentType.
   *
   * @param b64Data {String} Pure base64 string without contentType
   * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
   * @param sliceSize {Int} SliceSize to process the byteCharacters
   * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
   * @return Blob
   */
  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) /* istanbul ignore next */ {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  convertDataURIToBinaryFF(dataURI) {
    const BASE64_MARKER = ';base64,';
    const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    const raw = atob(dataURI.substring(base64Index));
    return Uint8Array.from(Array.prototype.map.call(raw, (x) => {
      return x.charCodeAt(0);
    }));
  }

  toHex(uint8arr: Uint8Array): string {
    if (!uint8arr) {
      return '';
    }
    let hexStr = '';
    for (let i = 0; i < uint8arr.length; i++) {
      // tslint:disable-next-line:no-bitwise
      let hex = (uint8arr[i] & 0xff).toString(16);
      hex = (hex.length === 1) ? '0' + hex : hex;
      hexStr += hex;
    }

    return hexStr.toLowerCase();
  }



  notSameTemplate(a, b) {
    if (a.isVisible !== b.isVisible) return 'isVisible';
    if (a.primaryColor !== b.primaryColor) return 'primaryColor';
    if (a.primaryText !== b.primaryText) return 'primaryText';
    if (a.secondaryText !== b.secondaryText) return 'secondaryText';
    if (a.position.x !== b.position.x) return 'position.x';
    if (a.position.y !== b.position.y) return 'position.x';
    if (a.id !== b.id) return 'id';
    return '';
  }


  notSameLayer(layerA, layerB) {
    if (layerA.sourceId !== layerB.sourceId) return 'sourceId';
    if (layerA.sourceName !== layerB.sourceName) return 'sourceName';
    if (layerA.sourceUrl !== layerB.sourceUrl) return 'sourceUrl';
    if (layerA.isSpotted !== layerB.isSpotted) return 'isSpotted';
    if (layerA.isHidden !== layerB.isHidden) return 'isHidden';
    if (layerA.number !== layerB.number) return 'number';
    if (layerA.type !== layerB.type) return 'type';
    if (layerA.position.x !== layerB.position.x) return 'pos.x';
    if (layerA.position.y !== layerB.position.y) return 'pos.y';
    if (layerA.position.width !== layerB.position.width) return 'pos.width';
    if (layerA.position.height !== layerB.position.height) return 'pos.height';
    // if (layerA.crop.left       !== layerB.crop.left) return 'crop.left';
    // if (layerA.crop.top        !== layerB.crop.top) return 'crop.top';
    // if (layerA.crop.right      !== layerB.crop.right) return 'crop.right';
    // if (layerA.crop.bottom     !== layerB.crop.bottom) return 'crop.bottom';
    return '';
  }

  public notSameChannel(a, b, checkPos = false): string {
    if (a === null || b === null) {
      return 'null';
    }
    if (a.layout !== b.layout) {
      return 'layout';
    }
    if (a.name !== b.name) {
      return 'name';
    }
    if (a.brandSettings !== b.brandSettings) {
      return 'brandsettings';
    }

    if (a.producerOrder.url !== b.producerOrder.url) {
      // order has changed
      return 'producerOrder';
    }
    if (a.eventStatus !== b.eventStatus) {
      return 'eventStatus';
    }
    if (a.updateReason?.group !== b.updateReason?.group) {
      console.log(a.updateReason, b.updateReason);
      return 'updateReason group';
    }
    if (a.updateReason?.action !== b.updateReason?.action) {
      console.log(a.updateReason, b.updateReason);
      return 'updateReason action';
    }
    if (a.updateReason?.id !== b.updateReason?.id) {
      console.log(a.updateReason, b.updateReason);
      return 'updateReason id';
    }
    if (a.updateReason?.value !== b.updateReason?.value) {
      console.log(a.updateReason, b.updateReason);
      return 'updateReason value';
    }

    if (a.layers.length !== b.layers.length) {
      return 'layer length';
    }
    for (let i = 0; i < a.layers.length; i++) {
      const diff = this.notSameLayer(a.layers[i], b.layers[i]);
      if (diff !== '') {
        return diff;
      }
    }
    if (a.templateAttributes && b.templateAttributes && a.templateAttributes.attributes && b.templateAttributes.attributes) {

      const diffLT = this.notSameTemplate(a.templateAttributes.attributes.find(attr => attr.type === TemplateType.T_LOWERTHIRD), b.templateAttributes.attributes.find(attr => attr.type === TemplateType.T_LOWERTHIRD));
      if (diffLT !== '') {
        return 'attributes.lowerthird ' + diffLT;
      }
      const diffTick = this.notSameTemplate(a.templateAttributes.attributes.find(attr => attr.type === TemplateType.T_TICKER), b.templateAttributes.attributes.find(attr => attr.type === TemplateType.T_TICKER));
      if (diffTick !== '') {
        return 'attributes.ticker ' + diffTick;
      }
      const logosA = a.templateAttributes.attributes.filter(attr => attr.type === TemplateType.T_LOGO);
      const logosB = b.templateAttributes.attributes.filter(attr => attr.type === TemplateType.T_LOGO);
      if (logosA.length !== logosB.length) {
        return 'attributes.logo.length';
      }
      for (let index = 0; index < logosA.length; index++) {
        const diffLogo = this.notSameTemplate(logosA[index], logosB[index]);
        if (diffLogo !== '') {
          return 'attributes.logo ' + diffLogo;
        }
      }
      const chatA = a.templateAttributes.attributes.filter(attr => attr.type === TemplateType.T_CHAT);
      const chatB = b.templateAttributes.attributes.filter(attr => attr.type === TemplateType.T_CHAT);
      if (chatA.length !== chatB.length) {
        return 'attributes.chat.length';
      }
      for (let index = 0; index < chatA.length; index++) {
        const diffChat = this.notSameTemplate(chatA[index], chatB[index]);
        if (diffChat !== '') {
          return 'attributes.chat ' + diffChat;
        }
      }
      const ntA = a.templateAttributes.attributes.filter(attr => attr.type === TemplateType.T_NAMETAG);
      const ntB = b.templateAttributes.attributes.filter(attr => attr.type === TemplateType.T_NAMETAG);
      if (ntA.length !== ntB.length) {
        return 'attributes.nametags length';
      }
      if (ntA[0].theme !== ntB[0].theme) {
        return 'attributes.nametags theme';
      }
    }
    return '';
  }

}
